import { useEffect, useState } from "react";
import styles from "./administrationManagment.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaPlusCircle } from "react-icons/fa";
import Popup from "components/Popup/popup";
import { getEmploy } from "services/employManagment/get-employ";
import { updateEmploy } from "services/employManagment/update-employ";
import { deleteEmploy } from "services/employManagment/delete-employ";
import { setEmploy } from "services/employManagment/set-employ";
import ErrorFailed from "components/errorFailed/errorFailed";
import { checkEmail } from "services/userLogin/check-email";
import SuccessPopup from "components/successPopup/successPopup";

export default function EmployManagment() {
    const [employData, setEmployData] = useState<{ is_super_user: Boolean, login_id: number; profile_id: number; first_name: string; last_name: string; email: string; is_admin: boolean; is_statistic: boolean; }[]>([]);
    const [editedEmploys, setEditedEmploys] = useState<{ [key: number]: { first_name: string; last_name: string; email: string; is_admin: boolean; is_statistic: boolean; } }>({});
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [newEmploy, setNewEmploy] = useState({ first_name: "", last_name: "", email: "", password: "", rePassword: "", is_admin: false, is_statistic: false });
    const [error, setError] = useState<string | null>(null);
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
    const fetchData = async () => {
        try {
            const employs = await getEmploy();
            const formattedEmploys = employs.map((employ: {
                is_super: string; is_admin: string; is_statistic: string;
            }) => ({
                ...employ,
                is_admin: employ.is_admin === "1",
                is_statistic: employ.is_statistic === "1",
                is_super_user: employ.is_super === "1"
            }));
            setEmployData(formattedEmploys);
        } catch (error) {
            console.error("Fehler beim Abrufen der Daten:", error);
        }
    };
    const [visibleIndex, setVisibleIndex] = useState<number | null>(null);

    const toggleFormVisibility = (index: number) => {
        setError(null);
        setVisibleIndex(visibleIndex === index ? null : index);
    };



    const handleUpdate = async (employ: { login_id: number; profile_id: number; first_name: string; last_name: string; email: string; is_admin: boolean; is_statistic: boolean; }) => {
        try {
            const res = await checkEmail(editedEmploys[employ.profile_id]?.email);
            if (res.exists && employ.email !== editedEmploys[employ.profile_id]?.email &&
                editedEmploys[employ.profile_id]?.email !== undefined) {
                setError("Die E-Mail-Adresse ist bereits vergeben.");
                return;
            }
            const updatedEmployData = {
                first_name: editedEmploys[employ.profile_id]?.first_name || employ.first_name,
                last_name: editedEmploys[employ.profile_id]?.last_name || employ.last_name,
                email: editedEmploys[employ.profile_id]?.email || employ.email,
                is_admin: editedEmploys[employ.profile_id]?.is_admin !== undefined ?
                    editedEmploys[employ.profile_id]?.is_admin : employ.is_admin,
                is_statistic: editedEmploys[employ.profile_id]?.is_statistic !== undefined ?
                    editedEmploys[employ.profile_id]?.is_statistic : employ.is_statistic,
            };
            await updateEmploy(employ.login_id, employ.profile_id, updatedEmployData);
            
            setIsSuccessPopupOpen(true)
            setError(null)
            fetchData();
        } catch (error) {
            console.error("Fehler beim Aktualisieren der Mitarbeiter:", error);
        }
    };
    const handleCheckboxChange = (profile_id: number, field: "is_admin" | "is_statistic") => {
        setEditedEmploys((prev) => {
            const updatedFields = {
                ...prev[profile_id],
                [field]: !prev[profile_id]?.[field]
            };

            if (field === "is_admin") {
                updatedFields["is_statistic"] = false;
            } else if (field === "is_statistic") {
                updatedFields["is_admin"] = false;
            }

            return {
                ...prev,
                [profile_id]: updatedFields
            };
        });
    };

    const handleAdd = async () => {
        const res = await checkEmail(newEmploy.email);
        if (res.exists) {
            setError("Die E-Mail-Adresse ist bereits vergeben.");
            return;
        }
        if (newEmploy.password !== newEmploy.rePassword) {
            setError("Passwörter stimmen nicht überein.");
            return;
        }
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*-_+?&])[A-Za-z\d@$!%*-_+?&]{8,}$/;
        if (!passwordRegex.test(newEmploy.password)) {
            setError(
                "Das Passwort muss mindestens 8 Zeichen lang sein, einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten."
            );
            return;
        }

        try {
            const employData = {
                first_name: newEmploy.first_name,
                last_name: newEmploy.last_name,
                email: newEmploy.email,
                password: newEmploy.password,
                is_admin: newEmploy.is_admin,
                is_statistic: newEmploy.is_statistic,
            };

            const a = await setEmploy(employData);
            fetchData();
            setIsSuccessPopupOpen(true)
        } catch (error) {
            console.error("Fehler beim Hinzufügen eines Mitarbeiters:", error);
            setError("Fehler beim Hinzufügen des Mitarbeiters.");
        }
    };

    const handlePopupClose = () => {
        setIsPopupOpen(false);
        setError(null)
        setNewEmploy({ first_name: "", last_name: "", email: "", password: "", rePassword: "", is_admin: false, is_statistic: false })
    };

    const handleDelete = async (login_id: number, profile_id: number) => {
        try {
            const a = await deleteEmploy(login_id, profile_id,);
            setIsSuccessPopupOpen(true)
            fetchData();
        } catch (error) {
            console.error("Fehler beim Löschen eines Mitarbeiters:", error);
        }

    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={styles.EditForm}>
            {employData.map((employ, index) => (
                <div key={`employ-${employ.profile_id}-${index}`}>
                    <div className={styles.itemHeade} onClick={() => toggleFormVisibility(index)}>
                        <p>{employ.first_name} {employ.last_name}</p>
                        {visibleIndex === index ? <IoIosArrowUp /> : <IoIosArrowDown />}
                    </div>
                    {visibleIndex === index && (
                        <div className={styles.FormContainer}>
                            {error && <ErrorFailed error={error} />}

                            {!employ.is_super_user && <div className={commonStyles.formGroupRow}>
                                <div className={styles.isActiveOptionsRow} key={`admin-${employ.profile_id}-${index}`}>
                                    <div className={styles.isActiveOptionsRowLabels}>
                                        <label>ist Admin</label>
                                    </div>
                                    <input
                                        checked={editedEmploys[employ.profile_id]?.is_admin !== undefined ? editedEmploys[employ.profile_id]?.is_admin : employ.is_admin}
                                        id={`is_admin-${employ.profile_id}`}
                                        type="checkbox"
                                        onChange={() => {
                                            if (employ.login_id !== 1 || employ.profile_id !== 1) {
                                                handleCheckboxChange(employ.profile_id, "is_admin");
                                            }
                                        }}
                                    />
                                </div>
                                <div className={styles.isActiveOptionsRow} key={`statistic-${employ.profile_id}-${index}`}>
                                    <div className={styles.isActiveOptionsRowLabels}>
                                        <label>ist statistik</label>
                                    </div>
                                    <input
                                        checked={editedEmploys[employ.profile_id]?.is_statistic !== undefined ? editedEmploys[employ.profile_id]?.is_statistic : employ.is_statistic}
                                        id={`is_statistic-${employ.profile_id}`}
                                        type="checkbox"
                                        onChange={() => {
                                            if (employ.login_id !== 1 || employ.profile_id !== 1) {
                                                handleCheckboxChange(employ.profile_id, "is_statistic");
                                            }
                                        }}
                                    />
                                </div>
                            </div>}
                            <div className={commonStyles.formGroupRow}>
                                <div className={commonStyles.formGroup}>
                                    <label htmlFor="first_name">Vorname*</label>
                                    <input
                                        type="text"
                                        id="first_name"
                                        name="first_name"
                                        value={editedEmploys[employ.profile_id]?.first_name || employ.first_name}
                                        onChange={(e) => {
                                            setEditedEmploys({
                                                ...editedEmploys,
                                                [employ.profile_id]: {
                                                    ...editedEmploys[employ.profile_id],
                                                    first_name: e.target.value,
                                                },
                                            });
                                        }}
                                        required
                                    />
                                </div>
                                <div className={commonStyles.formGroup}>
                                    <label htmlFor="last_name">Nachname*</label>
                                    <input
                                        type="text"
                                        id="last_name"
                                        name="last_name"
                                        value={editedEmploys[employ.profile_id]?.last_name || employ.last_name}
                                        onChange={(e) => {
                                            setEditedEmploys({
                                                ...editedEmploys,
                                                [employ.profile_id]: {
                                                    ...editedEmploys[employ.profile_id],
                                                    last_name: e.target.value,
                                                },
                                            });
                                        }}
                                        required
                                    />
                                </div>
                            </div>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="email">Email*</label>
                                <input
                                    type="text"
                                    id="email"
                                    name="email"
                                    value={editedEmploys[employ.profile_id]?.email || employ.email}
                                    readOnly={employ.is_super_user == true}
                                    onChange={(e) => {
                                        setEditedEmploys({
                                            ...editedEmploys,
                                            [employ.profile_id]: {
                                                ...editedEmploys[employ.profile_id],
                                                email: e.target.value,
                                            },
                                        });
                                    }}
                                    required
                                />
                            </div>

                            <div className={styles.actionButtons}>
                                {!employ.is_super_user ? (
                                    <button
                                        className={`${commonStyles.commonButton} ${commonStyles.backButton}`}
                                        onClick={() => handleDelete(employ.login_id, employ.profile_id)}
                                    >
                                        Löschen
                                    </button>
                                ) : <></>}
                                <button
                                    className={`${commonStyles.commonButton} ${commonStyles.submitButton}`}
                                    onClick={() => handleUpdate(employ)}
                                >
                                    Speichern
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            ))}


            <section className={styles.section}>
                <div className={styles.addButtonContainer}>
                    <button
                        type="button"
                        className={`${commonStyles.commonButton} ${styles.addfaqButton}`}
                        onClick={() => { setIsPopupOpen(true); }}
                    >
                        <span>Mitarbeiter hinzufügen</span>
                        <FaPlusCircle className={`${commonStyles.commonButtonIcon} ${styles.buttonIcon}`} />
                    </button>
                </div>
            </section>

            <Popup
                title={"Mitarbeiter hinzufügen"}
                submitLabel={"Hinzufügen"}
                closeLabel={"Abbrechen"}
                isWithButton={true}
                isOpen={isPopupOpen}
                onClose={handlePopupClose}
                onSubmit={handleAdd}
            >


                {error && <ErrorFailed error={error} />}
                <div className={commonStyles.formGroupRow}>
                    <div className={styles.isActiveOptionsRow} >
                        <div className={styles.isActiveOptionsRowLabels}>
                            <label>ist Admin</label>
                        </div>
                        <input
                            checked={newEmploy.is_admin}
                            type="checkbox"
                            onChange={() => setNewEmploy(prev => ({
                                ...prev,
                                is_admin: !prev.is_admin,
                                is_statistic: false,
                            }))}
                        />
                    </div>
                    <div className={styles.isActiveOptionsRow}>
                        <div className={styles.isActiveOptionsRowLabels}>
                            <label>ist statistik</label>
                        </div>
                        <input
                            checked={newEmploy.is_statistic}
                            type="checkbox"
                            onChange={() => setNewEmploy(prev => ({
                                ...prev,
                                is_statistic: !prev.is_statistic,
                                is_admin: false,
                            }))}
                        />
                    </div>
                </div>
                <div className={commonStyles.formGroupRow}>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="first_name">Vorname*</label>
                        <input
                            type="text"
                            id="first_name"
                            name="first_name"
                            value={newEmploy.first_name}
                            onChange={(e) => setNewEmploy({ ...newEmploy, first_name: e.target.value })}
                            required
                        />

                    </div>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="last_name">Nachname*</label>
                        <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            value={newEmploy.last_name}
                            onChange={(e) => setNewEmploy({ ...newEmploy, last_name: e.target.value })}
                            required
                        />
                    </div>
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="email">Email*</label>
                    <input
                        type="text"
                        id="email"
                        name="email"
                        value={newEmploy.email}
                        onChange={(e) => setNewEmploy({ ...newEmploy, email: e.target.value })}
                        required
                    />
                </div>
                <div className={commonStyles.formGroupRow}>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="password">Passwort*</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={newEmploy.password}
                            onChange={(e) => setNewEmploy({ ...newEmploy, password: e.target.value })}
                            required
                        />
                    </div>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="rePassword">Passwort wiederholen*</label>
                        <input
                            type="password"
                            id="rePassword"
                            name="rePassword"
                            value={newEmploy.rePassword}
                            onChange={(e) => setNewEmploy({ ...newEmploy, rePassword: e.target.value })}
                            required
                        />
                    </div>
                </div>
            </Popup>
            <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                handlePopupClose();
                setIsSuccessPopupOpen(false);
            }} />


        </div>
    );
}
